export default {"src":"/_next/static/media/mileprogram-earnmile-coin_to_mile.249a78b3.svg","height":121,"width":121,"blurWidth":0,"blurHeight":0};